<div class="create-wrapper">
  <div class="heading">
    <h2 class="heading__text">記事を作成</h2>
  </div>

  <form class="form" [formGroup]="form" (ngSubmit)="submit()">
    <mat-form-field class="form__title">
      <input
        matInput
        formControlName="title"
        type="text"
        autocomplete="off"
        placeholder="タイトル"
        required
        #input
      />
      <mat-error *ngIf="titleControl.hasError('required')"
        >必須入力です</mat-error
      >
      <mat-error *ngIf="titleControl.hasError('maxlength')"
        >文字数は最大で{{ titleMaxLength }}文字までです</mat-error
      >
      <mat-hint align="end"
        >{{ input.value.length }} / {{ titleMaxLength }}</mat-hint
      >
    </mat-form-field>
    <mat-form-field class="form__desctiption">
      <mat-label>説明</mat-label>
      <textarea
        formControlName="description"
        matInput
        placeholder="説明"
      ></textarea>
    </mat-form-field>
    <label for="file" *ngIf="!image">
      glbファイルを選択
      <input
        type="file"
        id="file"
        name="file"
        accept=".glb"
        (change)="getImage($event)"
        style="display: none"
      />
    </label>
    <div *ngIf="image">
      <p>{{ image.name }}</p>
      <button mat-button color="warn" (click)="cancel()">
        選択をキャンセル
      </button>
    </div>

    <mat-dialog-actions>
      <button
        mat-button
        type="submit"
        class="form__submit"
        [mat-dialog-close]="true"
        cdkFocusInitial
        [disabled]="form.invalid || form.pristine || !this.image"
        [class.form__submit--disabled]="
          form.invalid || form.pristine || !this.image
        "
      >
        作成
      </button>
      <button class="form__cancel" mat-button matDialogClose type="button">
        キャンセル
      </button>
    </mat-dialog-actions>
  </form>
</div>
